import React, { useState } from 'react'
import {
  Input,
  Popover,
  PopoverHandler,
  PopoverContent,
  Button,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Drawer,
} from "@material-tailwind/react";

import { XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function MenuBar(props) {
  const location = useLocation();

  const getCurrentRoute = () => {
    return location.pathname.split('/')[1] || '';
  }

  const currentRoute = getCurrentRoute();
  const wallet = useSelector((state) => state.wallet);
  const navigate = useNavigate();
  const { openRightMenu, closeRightMenu, rightMenu, deployCount} = props;

  return (
    <Drawer
      placement="right"
      open={rightMenu}
      onClose={closeRightMenu}
      className="py-4 px-2 bg-black text-white overflow-y-scroll z-[99999]"
    >
      <div className="flex flex-col gap-5 px-3">
        <div className="flex flex-row justify-between items-center mt-3 mb-6">
          <div className="text-white font-bold text-3xl">
            MENU
          </div>
          <XMarkIcon
            strokeWidth={2}
            className="h-6 w-6 cursor-pointer"
            onClick={closeRightMenu}
          />
        </div>
        <div className="flex flex-col gap-6">
          <div className={`hover:text-red-800 font-bold text-2xl mt-1 cursor-pointer ${currentRoute === 'about' ? 'text-red-800' : 'text-white'}`} onClick={() => navigate('/about')}>ABOUT</div>
          <div className={`hover:text-red-800 font-bold text-2xl mt-1 cursor-pointer ${currentRoute === 'news' ? 'text-red-800' : 'text-white'}`} onClick={() => navigate('/news')}>NEWS</div>
          {/* <div className="font-bold text-white text-2xl mt-1 cursor-pointer" >GALLERY</div>
          <div className="font-bold text-white text-2xl mt-1 cursor-pointer" >NEWS</div> */}
          <div className="flex flex-col">
            <div className="font-bold text-white text-2xl bg-red-800 px-2 py-1 rounded-md text-center cursor-pointer" onClick={() => navigate('/')}>MINT</div>
            <div className="text-white text-sm text-center bg-red-800 rounded-md mt-1 px-2">{deployCount}/21000</div>
          </div>
        </div>
      </div>
    </Drawer>
  )
}
